import gql from 'graphql-tag';

// eslint-disable-next-line import/prefer-default-export
export const getCoachingComments = gql`
  query GetCoachingComments(
    $noteID: String!
    $requesterAlias: String!
    $requesterRole: String!
  ) {
    getCoachingComments(
      noteID: $noteID
      requesterAlias: $requesterAlias
      requesterRole: $requesterRole
    ) {
      coachingID
      noteID
      commentThreads {
        commentThreadType
        commentThreadParticipants
        comments {
          authorAlias
          commentID
          timestamp
          comment
          receiverAlias
        }
      }
    }
  }
`;
